import type { Id } from "./ids";

export const FAVORITE_TARGETS = ["PLACE", "EVENT"] as const;
export type FavoriteTarget = (typeof FAVORITE_TARGETS)[number];

/** favorites 는 복합 PK (user_id, target_type, target_id) 다 — I-FV-01. */
export interface Favorite { targetType: FavoriteTarget; targetId: Id }

export function favoriteKey(f: Favorite): string {
  return `${f.targetType}:${f.targetId}`;
}
